// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media not all and (-webkit-min-device-pixel-ratio:0),not all and (min-resolution:0.001dpcm){@media{.input__hint[data-v-3f1483ac]{margin-top:0}.input .input__number[data-v-3f1483ac] .input-element{height:45px}}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
